import { render, staticRenderFns } from "./CookieBar.vue?vue&type=template&id=cde3beba&scoped=true"
import script from "./CookieBar.vue?vue&type=script&lang=js"
export * from "./CookieBar.vue?vue&type=script&lang=js"
import style0 from "./CookieBar.vue?vue&type=style&index=0&id=cde3beba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde3beba",
  null
  
)

export default component.exports